<i18n src="./../../i18n/navigation_bar.json"></i18n>

<template>
    <nav class="navbar navbar-expand-lg navbar-light py-0 py-md-0 sticky-top">
        <div class="container mt-navbar-container">
            <a v-if="isOnFrontPage" v-on:click="scrollToTop" class="navbar-brand pr-lg-2"><img class="lazy" data-src="/assets/mt-logo.png" alt="mToilet"></a>
            <router-link v-else :to="{name: 'home'}" class="navbar-brand pr-lg-2"><img class="lazy" data-src="/assets/mt-logo.png" alt="mToilet"></router-link>
            <div>
                <router-link :to="{name: 'basket'}" class="pr-3 mt-to-md-only">
                  <router-link :to="{name: 'buyOnline'}">
                    <button class="btn btn-secondary mt-button mt-button-secondary mt-button-blue-text p-2 pr-3 pl-3" v-text="$t('menu.buyNow')"/>
                  </router-link>
                </router-link>
                <router-link :to="{name: 'basket'}" class="pr-3 mt-to-md-only">
                    <div class="mt-cart-nav">
                        <img class="lazy" data-src="/assets/mt-cart.png" alt="cart">
                        <span class="mt-cart-counter text-center align-middle" :class="{'d-none': getCartQuantity == null || getCartQuantity === 0}" v-text="getCartQuantity"/>
                    </div>
                </router-link>
                <button class="navbar-toggler mt-1" type="button" data-toggle="collapse" data-target="#navbarContent" aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
            </div>

            <div class="collapse navbar-collapse" id="navbarContent">
                <ul class="navbar-nav">
                    <li class="nav-item" id="mt-nav-offer">
                        <router-link :to="{name: 'offer'}" class="nav-link pl-lg-2 pr-lg-2 pt-lg-4 pb-lg-4" v-text="$t('menu.positions.offer')"/>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'about'}" class="nav-link pl-lg-2 pr-lg-2 pt-lg-4 pb-lg-4" v-text="$t('menu.positions.about')"/>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'faq'}" class="nav-link pl-lg-2 pr-lg-2 pt-lg-4 pb-lg-4" v-text="$t('menu.positions.faq')"/>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'career'}" class="nav-link pl-lg-2 pr-lg-2 pt-lg-4 pb-lg-4" v-text="$t('menu.positions.work')"/>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'info'}" class="nav-link pl-lg-2 pr-lg-2 pt-lg-4 pb-lg-4" v-text="$t('menu.positions.news')"/>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'contact'}" class="nav-link pl-lg-2 pr-lg-2 pt-lg-4 pb-lg-4" v-text="$t('menu.positions.contact')"/>
                    </li>
                    <li v-if="Const.PRIMARY_LOCALE === 'pl' || Const.PRIMARY_LOCALE === 'lt'" class="nav-item pl-3 my-auto mt-md-only">
                        <router-link :to="{name: 'buyOnline'}">
                          <button class="btn btn-secondary mt-button mt-button-secondary mt-button-blue-text p-2" v-text="$t('menu.buyOnline')"/>
                        </router-link>
                    </li>
                    <li class="nav-item my-auto mt-md-only" :class="Const.PRIMARY_LOCALE === 'pl' || Const.PRIMARY_LOCALE === 'lt' ? 'pl-4' : 'pl-5'">
                        <div class="custom-sel">
                          <a v-for="loc in this.locales" :key="loc.locale" v-bind:class="{ 'selected': loc.active, 'hidden': !loc.active }" v-bind:href="loc.url" v-on:click="manageLocaleDropdown(loc, $event)">
                            {{loc.code}} <font-awesome-icon v-if="loc.active" class="mt-fa-icon mt-c-blue-light" icon="caret-down" aria-hidden="true"/>
                          </a>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="row mt-md-only">
                <div class="col-auto my-auto data-breach-link ml-auto text-center pr-lg-5">
                  <router-link v-if="Const.PRIMARY_LOCALE === 'pl'" to="/komunikat-o-naruszeniu-danych-osobowych-11-11-2025"><span>Komunikat o naruszeniu</span><br><span>z dnia 11.11.2025</span></router-link>
                </div>
                <div class="col-auto mt-5 mt-md-1">
                    <img class="lazy mr-2" data-src="/assets/mt-phone.png" alt="phone">
                    <span class="mt-f-regular mt-c-blue-regular mt-fs-large" v-text="contactPhone"></span>
                    <span class="mr-4"></span>
                    <router-link :to="{name: 'basket'}">
                        <div class="mt-cart-nav">
                            <img class="lazy" data-src="/assets/mt-cart.png" alt="cart">
                            <span class="mt-cart-counter text-center align-middle" :class="{'d-none': getCartQuantity == null || getCartQuantity === 0}">{{getCartQuantity}}</span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
    import {mapGetters} from "vuex";
    import $ from "jquery";
    import {Const} from "@/main";
    import store from "@/store";

    export default {
        name: "NavigationBar",
        data() {
          return {
            locale: this.$i18n.locale,
            contactPhone: Const.CONTACT_PHONE,
            locales: []
          }
        },
        props: {
            isOnFrontPage: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        mounted() {
            let app = this;
            Const.SUPPORTED_LOCALES.forEach(function (obj) {
                app.locales.push({
                    locale: obj.locale,
                    code: obj.code,
                    url: obj.url === "" ? "/en" : obj.url,
                    active: obj.locale === app.locale
                  })
            })
            app.locales.sort(function(x, y) {
                return (x.active === y.active)? 0 : x.active? -1 : 1;
            })

            $('.custom-sel').focusout(function() {
              app.hideLocaleDropdown()
            }).blur(function() {
              app.hideLocaleDropdown()
            });
        },
        computed: mapGetters([
            'getCartQuantity'
        ]),
        methods: {
            scrollToTop() {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            },
            manageLocaleDropdown(loc, e) {
                e.preventDefault()
                if (loc.active) {
                    $('.custom-sel').addClass('show-sel');
                    $('.custom-sel a').removeClass('hidden');
                } else {
                    if (loc.locale === Const.PRIMARY_LOCALE || loc.locale === 'en') {
                        store.dispatch('changeLocale', loc.locale);
                        location.reload();
                    } else {
                        window.location.href = loc.url;
                    }
                }
            },
            hideLocaleDropdown() {
                setTimeout(function () {
                    $('.custom-sel').removeClass('show-sel');
                    $('.custom-sel a:not(:first)').addClass('hidden');
                }, 200)
            }
        }
    }
</script>

<style scoped>
    @media (min-width: 1360px) {
        .mt-navbar-container {
            max-width: 1360px;
        }
    }

    .navbar-light {
        box-shadow: 0 2px 47px rgba(0, 0, 0, 0.1);
        background-color: #fff;
    }

    @media (max-width: 992px) {
        .navbar-light {
            background-color: #fff;
        }
    }

    .navbar-light .nav-item .nav-link {
        background-image: url("/assets/mt-nav-bg-hover.png");
        background-position: 0 -7px;
        background-repeat: repeat-x;
        transition: background-position 50ms linear;
    }

    .navbar-light .nav-item:hover .nav-link {
        background-position: 0 0;
        transition: background-position 50ms linear;
    }

    .navbar-light .nav-item .nav-link.active {
        background-image: url("/assets/mt-nav-bg.png");
        background-position: 0 0;
        transition: background-position 50ms linear;
    }

    @media (max-width: 992px) {
        .navbar-light .nav-item .nav-link {
            background-image: none;
            padding-left: 1vh;
            color: #4092e5;
        }

        .navbar-light .nav-item:hover .nav-link {
            background-image: none;
            background-color: #4092e5;
            color: #122840;
        }

        .navbar-light .nav-item .nav-link.active {
            background-image: none;
            background-color: #295d92;
            color: #fff;
        }
    }

    .navbar .row {
        width: 475px;
    }

    .mt-cart-nav {
        position: relative;
        display: inline-block;
    }

    .mt-cart-nav i {
        color: #295d92;
    }

    .mt-cart-counter {
        width: 22px;
        height: 22px;
        position: absolute;
        background: #4092e5;
        color: #fff;
        top: -5px;
        left: 25px;
        border-radius: 11px;
    }

    .navbar-brand {
        cursor: pointer;
    }

    .mt-button-blue-text {
        font-size: 16px;
        font-weight: bold;
        color: #4092e5 !important;
    }

    .mt-button-blue-text:hover {
      color: #4092e5 !important;
    }

    .custom-sel a {
      text-decoration: none;
      margin: 0;
      padding: 10px;
      text-align: left;
      color: #546e7a;
      font-weight: bold;
      display: block;
      cursor: pointer;
    }

    .custom-sel a:hover {
      text-decoration: none;
      background-color: #EDF0F2;
      color: #0071b3;
    }

    .custom-sel a.selected:hover {
      color: #546e7a;
    }

    .hidden {
      display: none !important;
    }

    .show-sel {
      position: absolute;
      top: 14px;
      background-color: #ffffff;
      box-shadow: -5px 0px 65px 0px rgba(0, 0, 0, 0.18);
    }

    .custom-sel {
      display: inline-block;
    }

    .data-breach-link {
      color: #4092e5;
      text-decoration: none;
      font-size: smaller;
      animation: pulseBlue 2s infinite;
      transition: color 0.3s ease;
    }

    .data-breach-link:hover {
      color: #0d6efd;
      text-decoration: underline;
    }

    @keyframes pulseBlue {
      0%, 100% {
        color: #4092e5 !important;
      }
      50% {
        color: #0d6efd;
      }
    }
</style>